import Form from '@admin/components/form'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Overview extends React.PureComponent {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, disabled: true },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Terms and Conditions)',
              name: 'agreed_to_terms',
              type: 'termsfield',
              maxHeight: '430px',
              terms: (
                <>
                  <p><strong>Truevail Affiliate Program Terms & Conditions</strong></p>
                  <p>Effective Date: May 12, 2025</p>
                  <p>&nbsp;</p>
                  <p>These Terms & Conditions (“Terms“) govern your participation in the Truevail Affiliate Program (“Program“) offered by Gold Start, LLC (Truevail). By enrolling in the Program, you agree to comply with and be bound by the following Terms</p>
                  <p>&nbsp;</p>
                  <p><strong>1. Eligibility</strong></p>
                  <p>The Truevail Affiliate Program is open to any individual or business with a valid PayPal or Venmo account, including current Truevail members</p>                  
                  <p>&nbsp;</p>
                  <p><strong>2. How It Works</strong></p>
                  <ul>
                    <li>Once you opt in to the Program, you will receive a unique referral link and customizable sign-up page within your Truevail account</li>
                    <li>You may share this referral link with your audience via email, social media, blog, website, or direct communication</li>
                    <li>If someone signs up for Truevail using your referral link and becomes a paying subscriber, you will earn a 15% commission on their monthly subscription fee —limited to our standard 'Essentials' plan</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><u>Important</u>:</p>
                  <ul>
                    <li>Commissions are only paid on the recurring monthly subscription cost of the Essentials plan. They do not apply to one-time charges such as setup fees, website design packages, creative service fees, consultation services, or any add-on offerings outside of the base subscription</li>
                    <li>Commission payments will begin only after your referral completes their 30-day free trial and transitions to a paying subscription. This timeline may vary depending on when the advisor finishes setup and activates billing</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><strong>3. Payout Terms</strong></p>
                  <ul>
                    <li>Affiliate commissions are calculated monthly</li>
                    <li>Payments will be sent via PayPal by the 5th of each month, covering commission earned in the prior calendar month</li>
                    <li>You must connect your PayPal or Venmo account within your Truevail dashboard to receive payments</li>
                    <li>No other payout methods are supported at this time</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><strong>4. Commission Structure</strong></p>
                  <ul>
                    <li>The base commission rate is 15% of the referred advisor's recurring monthly subscription to the Essentials plan.</li>
                    <li>Truevail may offer a custom commission rate to select affiliates, based on a mutually agreed-upon arrangement. Any such custom agreement must be confirmed in writing by both parties.</li>

                    <li>You will earn a 15% recurring commission on each referred advisor's paid monthly subscription</li>
                    <li>There is no limit to the number of advisors you can refer or commissions you can earn</li>
                    <li>Commissions will continue monthly for as long as the referred advisor maintains a paid Truevail subscription</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><strong>5. Referral Validity</strong></p>
                  <ul>
                    <li>Referrals are valid only when a new user signs up through your unique link and subscribes to a paid plan</li>
                    <li>If the referral cancels before becoming a paying member, no commission is earned</li>
                    <li>Self-referrals (signing up using your own link) are not eligible for commission</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><strong>6. Promotion Guidelines</strong></p>
                  <ul>
                    <li>Affiliates may promote their referral link through organic content (emails, blogs, social media, etc.)</li>
                    <li>Paid advertising to promote your referral link (including but not limited to Google Ads, Facebook Ads, Instagram promotions) is not permitted</li>
                    <li>You must clearly disclose that you may receive a commission when promoting Truevail, in compliance with FTC guidelines (e.g., “This is an affiliate link, and I may earn a small commission if you sign up.”)</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><strong>7. Termination & Changes</strong></p>
                  <ul>
                    <li>You may leave the program at any time by deactivating your affiliate link in your dashboard</li>
                    <li>Truevail reserves the right to update or modify these Terms or discontinue the Program at any time, with or without notice</li>
                    <li>Any misuse of the Program (e.g., spamming, false advertising, misrepresentation) may result in termination and forfeiture of unpaid commissions</li>
                  </ul>
                  <p>&nbsp;</p>
                  <p><strong>8. Support</strong></p>
                  <ul>
                    <li>For questions or assistance related to your affiliate account, payouts, or tracking, please email us at <a href="mailto:support@truevail.com">support@truevail.com</a></li>
                  </ul>
                  <p>&nbsp;</p>
                  <p>By joining the Truevail Affiliate Program, you acknowledge and agree to these Terms. We're excited to have you as part of our community and look forward to helping you grow your passive income while sharing a tool you believe in</p>
                </>
              ),
              prompt: 't(I agree to the terms and conditions)',
              required: true
            }
          ]
        }
      ]
    }
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(affiliate) {
    this.props.onNext(affiliate)
  }

}

export default Overview
